export type GuidelineSearchResult = {
  organisationId: string;
  uniqueId: string;
  title: string;
  snippet: string;
  navigationPath: string;
  score?: number;
};

export type GuidelineFullTextFilter = {
  searchText: string;
  taxonomyIds: string[];
  showShared?: boolean;
  showImported?: boolean;
  showExpired?: boolean;
};

export enum GuidelineSearchResultMatchingField {
  None = 0,
  Guideline = 1,
  Chapter = 2,
  Component = 3,
  Flowchart = 4,
  Attachment = 5,
}

export const matchingFieldIconMap: Record<GuidelineSearchResultMatchingField, string> = {
  [GuidelineSearchResultMatchingField.None]: 'book',
  [GuidelineSearchResultMatchingField.Guideline]: 'book',
  [GuidelineSearchResultMatchingField.Chapter]: 'bookmark',
  [GuidelineSearchResultMatchingField.Component]: 'component',
  [GuidelineSearchResultMatchingField.Flowchart]: 'git-fork',
  [GuidelineSearchResultMatchingField.Attachment]: 'file',
};

export const iconTooltipTranslationKeyMap: Record<GuidelineSearchResultMatchingField, string> = {
  [GuidelineSearchResultMatchingField.None]: 'Guideline',
  [GuidelineSearchResultMatchingField.Guideline]: 'Guideline',
  [GuidelineSearchResultMatchingField.Chapter]: 'Chapter',
  [GuidelineSearchResultMatchingField.Component]: 'Component',
  [GuidelineSearchResultMatchingField.Flowchart]: 'Flowchart',
  [GuidelineSearchResultMatchingField.Attachment]: 'Attachment',
};

export const pathTooltipTranslationKeyMap: Record<GuidelineSearchResultMatchingField, string> = {
  [GuidelineSearchResultMatchingField.None]: 'GoToGuideline',
  [GuidelineSearchResultMatchingField.Guideline]: 'GoToGuideline',
  [GuidelineSearchResultMatchingField.Chapter]: 'GoToChapter',
  [GuidelineSearchResultMatchingField.Component]: 'GoToComponent',
  [GuidelineSearchResultMatchingField.Flowchart]: 'GoToFlowchart',
  [GuidelineSearchResultMatchingField.Attachment]: 'GoToGuideline',
};
